<script>
  import {dd} from 'systems/imports'
  import InputFeedback from "components/widget/InputFeedback.vue"

  export default {
    created(){
    },
    components:{
      InputFeedback,
    },
  };
</script>



// WEBPACK FOOTER //
// FormPartialBase.vue?61d502dc